import React, { useState } from "react"
import { Button } from "react-bootstrap"

import RunDetailsModal from "./fermmanagement/modals/RunDetailsModal"

// TODO - These registrations are separate as they have import conflicts on LL when brought together

export const toggle_annotations_button = {
  EditAnnotationsModal: <></>,
  CreateAnnotationModal: <></>,
}

export const RunInfoPopover = ({ run = {}, onHide, intl }) => {
  const [show, setShow] = useState(false)

  return (
    <>
      {show && (
        <RunDetailsModal
          run={run}
          show={show}
          onHide={() => {
            setShow(false)
            onHide && onHide()
          }}
          intl={intl}
        />
      )}
      <Button
        variant={"outline-primary"}
        className={"btn-extra-sm"}
        style={{ alignSelf: "center" }}
        title={`${intl.formatMessage({ id: "general.run", defaultMessage: "Run" })}: ${run.id}`}
        size={"sm"}
        onClick={() => setShow(!show)}
      >
        <span className={"fa fa-list-alt"} />
        &nbsp;&nbsp;
        {intl.formatMessage({
          id: "general.view",
          defaultMessage: "View",
        })}
      </Button>
    </>
  )
}
